import React from 'react';
import { Modal, Spinner } from 'react-bootstrap';

const LoadingModal = ({ show, message = "Loading..." }) => {
  return (
    <Modal show={show} centered backdrop="static" keyboard={false}>
      <Modal.Body className="text-center d-flex flex-column align-items-center justify-content-center py-4">
        <Spinner animation="border" role="status" variant="primary" />
        <div className="mt-3">{message}</div>
      </Modal.Body>
    </Modal>
  );
};

export default LoadingModal;
